import { Fragment, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Button, Col, DatePicker, Input, Modal, Row, Space, Form, Radio, Checkbox } from "antd"
import { baseAxiosComplete, baseAxiosNoInfo } from "../../../tool/axios"
import { useForm } from "antd/lib/form/Form"
import _ from 'lodash'

const formItemLayout = {
    labelCol: { span: 3 },
    wrapperCol: { span: 14 }
}

interface Prop {
    storeID?: string
}

interface Client {
    check_in_id: string // 入住id
    check_in_user_name: string // 客人姓名
    check_in_phone: string // 手机号码
    preg_status_desc: string // 怀孕时期
    expect_born_day: string // 预产期（预计入住时间）
    actually_born_day: string // 分娩日
    check_in_time: string // 实际入住时间
    check_out_time_init: string // 预计出所时间
    check_out_time_finally: string // 实际出所时间
    accompany_man_name: string // 陪护人
    accompany_phone: string // 陪护人手机号
    emergency_man_name: string // 紧急联系人
    emergency_phone: string // 紧急联系人手机号
    deal_item_name: string // 签单套餐名称
    check_in_total_days: number // 入住总天数，整数类型
    check_in_already_days: number // 已入住天数，整数类型
    check_in_left_days: number // 剩余天数，整数类型
    item_days: number // 套餐入住天数，整数类型
    gift_days: number // 赠送天数，整数类型
    deal_records_remark: string // 签单备注
    store_id: string // 签单门店id
    deal_prov_pic_list: string // 合同凭证图片
}

export default function (prop: Prop) {

    const param: { id: string } = useParams()

    const [visible, setVisible] = useState<boolean>(false)
    const [clientData, setClientData] = useState<Client>()
    const [currentDay, setCuurentDay] = useState<string>('R1')
    const [form] = useForm()
    const [form2] = useForm()
    const [form3] = useForm()
    const [form4] = useForm()
    const [form5] = useForm()
    const [form6] = useForm()
    const [form7] = useForm()
    const [form8] = useForm()
    const [form9] = useForm()

    const [unFillForm, setUnfillForm] = useState<string[]>([])

    const getClientInfo = () => {
        baseAxiosNoInfo('/keeper/check_in/detail/base_info', {
            params: {
                check_in_id: param.id
            }
        }).then((res: any) => {
            if (res) {
                setClientData(res)
            }
        })
    }

    useEffect(() => {
        getClientInfo()

        // 查询未填回访tab 
        baseAxiosNoInfo('/keeper/check_in/detail/interview/missing_interview_type_list', {
            params: {
                check_in_id: param.id
            }
        }).then((res: any) => {
            res && setUnfillForm(res)
        })
    }, [])

    const onFinish = () => {
        if (currentDay === 'R1') {
            baseAxiosComplete.post('/keeper/check_in/detail/add_interview_records', {
                check_in_id: param.id,
                interview_dic_code: currentDay,
                interview_date: form.getFieldValue('interview_date').format('YYYY-MM-DD'),
                other_exception: form.getFieldValue('other_exception'),
                room_cosy_level: form.getFieldValue('room_cosy_level'),
                room_service_level: form.getFieldValue('room_service_level').join(','),
                second_day_prop_edu: form.getFieldValue('second_day_prop_edu').join(','),
            }).then(res => {
                if (res.status === 0) {
                    setVisible(false)
                }
            })
        }

        if (currentDay === 'R2') {
            baseAxiosComplete.post('/keeper/check_in/detail/add_interview_records', {
                check_in_id: param.id,
                interview_dic_code: currentDay,
                interview_date: form2.getFieldValue('interview_date').format('YYYY-MM-DD'),
                other_exception: form2.getFieldValue('other_exception'),
                first_night_feel_level: form2.getFieldValue('first_night_feel_level'),
                in_hospital_date: form2.getFieldValue('in_hospital_date') ? form2.getFieldValue('in_hospital_date').format('YYYY-MM-DD') : null,
                sleep_level: form2.getFieldValue('sleep_level'),
                second_day_injury_level: form2.getFieldValue('second_day_injury_level'),
                baby_level: form2.getFieldValue('baby_level'),
                second_day_food_level: form2.getFieldValue('second_day_food_level'),
            }).then(res => {
                if (res.status === 0) {
                    setVisible(false)
                }
            })
        }

        if (currentDay === 'R3') {
            baseAxiosComplete.post('/keeper/check_in/detail/add_interview_records', {
                check_in_id: param.id,
                interview_dic_code: currentDay,
                interview_date: form3.getFieldValue('interview_date').format('YYYY-MM-DD'),
                other_exception: form3.getFieldValue('other_exception'),
                third_day_prop_edu: form3.getFieldValue('third_day_prop_edu').join(','),
                third_day_injury_level: form3.getFieldValue('third_day_injury_level'),
                breast_level: form3.getFieldValue('breast_level')
            }).then(res => {
                if (res.status === 0) {
                    setVisible(false)
                }
            })
        }

        if (currentDay === 'R4') {
            baseAxiosComplete.post('/keeper/check_in/detail/add_interview_records', {
                check_in_id: param.id,
                interview_dic_code: currentDay,
                interview_date: form4.getFieldValue('interview_date').format('YYYY-MM-DD'),
                other_exception: form4.getFieldValue('other_exception'),
                nurse_level: form4.getFieldValue('nurse_level'),
                room_clean_level: form4.getFieldValue('room_clean_level'),
                tenth_day_food_level: form4.getFieldValue('tenth_day_food_level'),
                chankang_service_level: form4.getFieldValue('chankang_service_level'),
                minion_level: form4.getFieldValue('minion_level'),
                doctor_level: form4.getFieldValue('doctor_level')
            }).then(res => {
                if (res.status === 0) {
                    setVisible(false)
                }
            })
        }

        if (currentDay === 'R5') {
            baseAxiosComplete.post('/keeper/check_in/detail/add_interview_records', {
                check_in_id: param.id,
                interview_dic_code: currentDay,
                interview_date: form5.getFieldValue('interview_date').format('YYYY-MM-DD'),
                other_exception: form5.getFieldValue('other_exception'),
                mom_class: form5.getFieldValue('mom_class'),
                continue_intention: form5.getFieldValue('continue_intention')
            }).then(res => {
                if (res.status === 0) {
                    setVisible(false)
                }
            })
        }

        if (currentDay === 'R6') {
            baseAxiosComplete.post('/keeper/check_in/detail/add_interview_records', {
                check_in_id: param.id,
                interview_dic_code: currentDay,
                interview_date: form6.getFieldValue('interview_date').format('YYYY-MM-DD'),
                other_exception: form6.getFieldValue('other_exception'),
                tweenty_fourth_mom_recovery: form6.getFieldValue('tweenty_fourth_mom_recovery'),
                tweenty_fourth_baby_sleep_grow: form6.getFieldValue('tweenty_fourth_baby_sleep_grow')
            }).then(res => {
                if (res.status === 0) {
                    setVisible(false)
                }
            })
        }

        if (currentDay === 'R7') {
            baseAxiosComplete.post('/keeper/check_in/detail/add_interview_records', {
                check_in_id: param.id,
                interview_dic_code: currentDay,
                interview_date: form7.getFieldValue('interview_date').format('YYYY-MM-DD'),
                other_exception: form7.getFieldValue('other_exception'),
                thirty_second_mom_recovery: form7.getFieldValue('thirty_second_mom_recovery'),
                thirty_second_baby_sleep_grow: form7.getFieldValue('thirty_second_baby_sleep_grow'),
                lochia: form7.getFieldValue('lochia'),
                all_dep_service_level: form7.getFieldValue('all_dep_service_level'),
                baby_vaccine: form7.getFieldValue('baby_vaccine'),
            }).then(res => {
                if (res.status === 0) {
                    setVisible(false)
                }
            })
        }

        if (currentDay === 'L1') {
            baseAxiosComplete.post('/keeper/check_in/detail/add_interview_records', {
                check_in_id: param.id,
                interview_dic_code: currentDay,
                interview_date: form8.getFieldValue('interview_date').format('YYYY-MM-DD'),
                expect_leave_date: form8.getFieldValue('expect_leave_date').format('YYYY-MM-DD'),
                other_exception: form8.getFieldValue('other_exception'),
                leave_before_three_prop_edu: form8.getFieldValue('leave_before_three_prop_edu') ? form8.getFieldValue('leave_before_three_prop_edu').join(',') : null,
                leave_before_three_food: form8.getFieldValue('leave_before_three_food') ? form8.getFieldValue('leave_before_three_food').join(',') : null,
            }).then(res => {
                if (res.status === 0) {
                    setVisible(false)
                }
            })
        }

        if (currentDay === 'L2') {
            baseAxiosComplete.post('/keeper/check_in/detail/add_interview_records', {
                check_in_id: param.id,
                interview_dic_code: currentDay,
                interview_date: form9.getFieldValue('interview_date').format('YYYY-MM-DD'),
                other_exception: form9.getFieldValue('other_exception'),
                leave_before_one_prop_edu: form9.getFieldValue('leave_before_one_prop_edu') ? form9.getFieldValue('leave_before_one_prop_edu').join(',') : null,
                destination: form9.getFieldValue('destination'),
            }).then(res => {
                if (res.status === 0) {
                    setVisible(false)
                }
            })
        }
    }

    const options = [
        { label: '倒茶水', value: '1' },
        { label: '试穿月子服', value: '2' },
        { label: '试穿月子鞋', value: '3' },
        { label: '送行李', value: '4' },
    ]

    const options2 = [
        { label: '电话', value: '1' },
        { label: '各部门介绍', value: '2' },
        { label: '家属餐', value: '3' },
        { label: '停车费', value: '4' },
        { label: '探访', value: '5' },
        { label: '门锁', value: '6' },
        { label: 'WIFI', value: '7' }
    ]

    const options3 = [
        { label: '医生查房规律告知', value: '1' },
        { label: '妈咪课堂介绍', value: '2' },
        { label: '产后项目安排', value: '3' },
        { label: '宣教适当通风/活动', value: '4' },
        { label: '宝宝黄疸情况', value: '5' },
        { label: '体质分析安排', value: '6' }
    ]

    const options4 = [
        { label: '体质分析', value: '1' },
        { label: '离所宣导', value: '2' },
        { label: '满意度调查表', value: '3' },
        { label: '告知停车票报销', value: '4' }
    ]

    const options5 = [
        { label: '早餐', value: '1' },
        { label: '早茶', value: '2' },
        { label: '午餐', value: '3' },
        { label: '下午茶', value: '4' },
        { label: '晚餐', value: '5' }
    ]

    const options6 = [
        { label: '用早餐、喂奶', value: '1' },
        { label: '宝宝物品、存奶收拾好拿到房间', value: '2' },
        { label: '收拾好行李让工作人员搬行李', value: '3' },
        { label: '等待客房部门查房', value: '4' },
        { label: '带上两张门禁卡/押金条办理手续', value: '5' },
        { label: '可带走、不可带走物品', value: '6' },
    ]

    return <Fragment>
        {/* 管家中心 -> 入住管理 -> 客户详情 -> 添加入住回访 */}
        <Button type="primary" style={{ marginLeft: 16, marginBottom: 16 }} size="small" onClick={() => { setVisible(true) }}>添加入住回访</Button>

        <Modal title="添加入住回访" width={1200} visible={visible} onCancel={() => { setVisible(false) }} onOk={onFinish}>
            <Row>
                <Col span={6}>
                    <div>
                        <Space>
                            <p>客人姓名：</p>
                            <p>{clientData?.check_in_user_name}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>手机号码：</p>
                            <p>{clientData?.check_in_phone}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>怀孕时期：</p>
                            <p>{clientData?.preg_status_desc}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>预产期/分娩日：</p>
                            <p>{clientData?.expect_born_day}/{clientData?.actually_born_day}</p>
                        </Space>
                    </div>
                </Col>

                <Col span={6}>
                    <div>
                        <Space>
                            <p>实际入住日期：</p>
                            <p>{clientData?.check_in_time}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>预计出所日期：</p>
                            <p>{clientData?.check_out_time_init}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>实际出所日期：</p>
                            <p>{clientData?.check_out_time_finally}</p>
                        </Space>
                    </div>
                </Col>

                <Col span={6}>
                    <div>
                        <Space>
                            <p>陪护人：</p>
                            <p>{clientData?.accompany_man_name}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>陪护人手机：</p>
                            <p>{clientData?.accompany_phone}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>紧急联系人：</p>
                            <p>{clientData?.emergency_man_name}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>紧急联系人手机：</p>
                            <p>{clientData?.emergency_phone}</p>
                        </Space>
                    </div>
                </Col>

                <Col span={6}>
                    <div>
                        <Space>
                            <p>预住总天数：</p>
                            <p>{clientData?.check_in_total_days}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>已入住天数：</p>
                            <p>{clientData?.check_in_already_days}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>剩余天数：</p>
                            <p>{clientData?.check_in_left_days}</p>
                        </Space>
                    </div>
                </Col>
            </Row>

            <p style={{ color: 'blue', margin: '10px 0' }}>蓝色下边框代表未填写回访记录</p>

            <div>
                <Space direction="horizontal" wrap >
                    <p onClick={() => { setCuurentDay('R1') }} style={{ cursor: 'pointer', paddingRight: 10, marginBottom: 15, borderBottom: unFillForm.includes('R1') ? '2px solid blue' : '' }} className={currentDay === 'R1' ? 'current' : ''}>入住当天</p>
                    <p onClick={() => { setCuurentDay('R2') }} style={{ cursor: 'pointer', paddingRight: 10, marginBottom: 15, borderBottom: unFillForm.includes('R2') ? '2px solid blue' : '' }} className={currentDay === 'R2' ? 'current' : ''}>入住第2天</p>
                    <p onClick={() => { setCuurentDay('R3') }} style={{ cursor: 'pointer', paddingRight: 10, marginBottom: 15, borderBottom: unFillForm.includes('R3') ? '2px solid blue' : '' }} className={currentDay === 'R3' ? 'current' : ''}>入住第3天</p>
                    <p onClick={() => { setCuurentDay('R4') }} style={{ cursor: 'pointer', paddingRight: 10, marginBottom: 15, borderBottom: unFillForm.includes('R4') ? '2px solid blue' : '' }} className={currentDay === 'R4' ? 'current' : ''}>入住第10-12天</p>
                    <p onClick={() => { setCuurentDay('R5') }} style={{ cursor: 'pointer', paddingRight: 10, marginBottom: 15, borderBottom: unFillForm.includes('R5') ? '2px solid blue' : '' }} className={currentDay === 'R5' ? 'current' : ''}>入住第17-19天</p>
                    <p onClick={() => { setCuurentDay('R6') }} style={{ cursor: 'pointer', paddingRight: 10, marginBottom: 15, borderBottom: unFillForm.includes('R6') ? '2px solid blue' : '' }} className={currentDay === 'R6' ? 'current' : ''}>入住第24-26天</p>
                    <p onClick={() => { setCuurentDay('R7') }} style={{ cursor: 'pointer', paddingRight: 10, marginBottom: 15, borderBottom: unFillForm.includes('R7') ? '2px solid blue' : '' }} className={currentDay === 'R7' ? 'current' : ''}>入住第32-34天</p>
                    <p onClick={() => { setCuurentDay('L1') }} style={{ cursor: 'pointer', paddingRight: 10, marginBottom: 15, borderBottom: unFillForm.includes('L1') ? '2px solid blue' : '' }} className={currentDay === 'L1' ? 'current' : ''}>离所前3天</p>
                    <p onClick={() => { setCuurentDay('L2') }} style={{ cursor: 'pointer', paddingRight: 10, marginBottom: 15, borderBottom: unFillForm.includes('L2') ? '2px solid blue' : '' }} className={currentDay === 'L2' ? 'current' : ''}>离所前1天</p>
                </Space>
            </div>

            {currentDay === 'R1' && <div>
                <Form form={form} {...formItemLayout} style={{ marginTop: 10 }}>
                    <Form.Item label="回访时间" name="interview_date">
                        <DatePicker />
                    </Form.Item>
                    <Form.Item label="房间舒适度" name="room_cosy_level">
                        <Radio.Group >
                            <Radio value={0}>未知（默认）</Radio>
                            <Radio value={1}>很满意</Radio>
                            <Radio value={2}>满意</Radio>
                            <Radio value={3}>一般</Radio>
                            <Radio value={4}>不满意</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item label="房间服务" name="room_service_level">
                        <Checkbox.Group options={options} />
                    </Form.Item>
                    <Form.Item label="宣教" name="second_day_prop_edu">
                        <Checkbox.Group options={options2} />
                    </Form.Item>
                    <Form.Item label="其他异常" name="other_exception">
                        <Input placeholder="" />
                    </Form.Item>
                </Form>
            </div>}

            {currentDay === 'R2' && <div>
                <Form form={form2} {...formItemLayout} style={{ marginTop: 10 }}>
                    <Form.Item label="回访时间" name="interview_date">
                        <DatePicker />
                    </Form.Item>
                    <Form.Item label="产妇入住首晚的感受" name="first_night_feel_level">
                        <Radio.Group >
                            <Radio value={0}>未知（默认）</Radio>
                            <Radio value={1}>很满意</Radio>
                            <Radio value={2}>满意</Radio>
                            <Radio value={3}>适应中</Radio>
                            <Radio value={4}>不习惯</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item label="餐食情况" name="second_day_food_level">
                        <Radio.Group >
                            <Radio value={0}>未知（默认）</Radio>
                            <Radio value={1}>很满意</Radio>
                            <Radio value={2}>满意</Radio>
                            <Radio value={3}>一般</Radio>
                            <Radio value={4}>不满意</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item label="睡眠情况" name="sleep_level">
                        <Radio.Group >
                            <Radio value={0}>未知（默认）</Radio>
                            <Radio value={1}>良好</Radio>
                            <Radio value={2}>一般</Radio>
                            <Radio value={3}>无法入眠</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item label="伤口情况" name="second_day_injury_level">
                        <Radio.Group >
                            <Radio value={0}>未知（默认）</Radio>
                            <Radio value={1}>恢复良好</Radio>
                            <Radio value={2}>一般</Radio>
                            <Radio value={3}>异常疼痛</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item label="宝宝情况" name="baby_level">
                        <Radio.Group >
                            <Radio value={0}>未知（默认）</Radio>
                            <Radio value={1}>一切正常</Radio>
                            <Radio value={2}>黄疸偏高</Radio>
                            <Radio value={3}>宝宝生病</Radio>
                            <Radio value={4}>住院未归</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item label="住院日期（非必填）" name="in_hospital_date">
                        <DatePicker />
                    </Form.Item>
                    <Form.Item label="其他异常" name="other_exception">
                        <Input placeholder="" />
                    </Form.Item>
                </Form>
            </div>}

            {currentDay === 'R3' && <div>
                <Form form={form3} {...formItemLayout} style={{ marginTop: 10 }}>
                    <Form.Item label="回访时间" name="interview_date">
                        <DatePicker />
                    </Form.Item>
                    <Form.Item label="宣导" name="third_day_prop_edu">
                        <Checkbox.Group options={options3} />
                    </Form.Item>
                    <Form.Item label="伤口情况" name="third_day_injury_level">
                        <Radio.Group >
                            <Radio value={0}>未知（默认）</Radio>
                            <Radio value={1}>恢复良好</Radio>
                            <Radio value={2}>一般</Radio>
                            <Radio value={3}>异常疼痛</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item label="乳房情况" name="breast_level">
                        <Radio.Group >
                            <Radio value={0}>未知（默认）</Radio>
                            <Radio value={1}>良好</Radio>
                            <Radio value={2}>奶量多</Radio>
                            <Radio value={3}>奶量少</Radio>
                            <Radio value={4}>乳腺炎</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item label="其他异常" name="other_exception">
                        <Input placeholder="" />
                    </Form.Item>
                </Form>
            </div>}

            {currentDay === 'R4' && <div>
                <Form form={form4} {...formItemLayout} style={{ marginTop: 10 }}>
                    <Form.Item label="回访时间" name="interview_date">
                        <DatePicker />
                    </Form.Item>
                    <Form.Item label="护士/护理师" name="nurse_level">
                        <Radio.Group >
                            <Radio value={0}>未知（默认）</Radio>
                            <Radio value={1}>很满意</Radio>
                            <Radio value={2}>满意</Radio>
                            <Radio value={3}>一般</Radio>
                            <Radio value={4}>不满意</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item label="客房保洁" name="room_clean_level">
                        <Radio.Group >
                            <Radio value={0}>未知（默认）</Radio>
                            <Radio value={1}>很满意</Radio>
                            <Radio value={2}>满意</Radio>
                            <Radio value={3}>一般</Radio>
                            <Radio value={4}>不满意</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item label="营养师/餐食" name="tenth_day_food_level">
                        <Radio.Group >
                            <Radio value={0}>未知（默认）</Radio>
                            <Radio value={1}>很满意</Radio>
                            <Radio value={2}>满意</Radio>
                            <Radio value={3}>一般</Radio>
                            <Radio value={4}>不满意</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item label="产康服务" name="chankang_service_level">
                        <Radio.Group >
                            <Radio value={0}>未知（默认）</Radio>
                            <Radio value={1}>很满意</Radio>
                            <Radio value={2}>满意</Radio>
                            <Radio value={3}>一般</Radio>
                            <Radio value={4}>不满意</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item label="管家服务" name="minion_level">
                        <Radio.Group >
                            <Radio value={0}>未知（默认）</Radio>
                            <Radio value={1}>很满意</Radio>
                            <Radio value={2}>满意</Radio>
                            <Radio value={3}>一般</Radio>
                            <Radio value={4}>不满意</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item label="查房医生" name="doctor_level">
                        <Radio.Group >
                            <Radio value={0}>未知（默认）</Radio>
                            <Radio value={1}>很满意</Radio>
                            <Radio value={2}>满意</Radio>
                            <Radio value={3}>一般</Radio>
                            <Radio value={4}>不满意</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item label="其他异常" name="other_exception">
                        <Input placeholder="" />
                    </Form.Item>
                </Form>
            </div>}

            {currentDay === 'R5' && <div>
                <Form form={form5} {...formItemLayout} style={{ marginTop: 10 }}>
                    <Form.Item label="回访时间" name="interview_date">
                        <DatePicker />
                    </Form.Item>
                    <Form.Item label="妈咪课堂上课情况" name="mom_class">
                        <Input />
                    </Form.Item>
                    <Form.Item label="续住意向沟通" name="continue_intention">
                        <Input />
                    </Form.Item>
                    <Form.Item label="其他异常" name="other_exception">
                        <Input placeholder="" />
                    </Form.Item>
                </Form>
            </div>}

            {currentDay === 'R6' && <div>
                <Form form={form6} {...formItemLayout} style={{ marginTop: 10 }}>
                    <Form.Item label="回访时间" name="interview_date">
                        <DatePicker />
                    </Form.Item>
                    <Form.Item label="妈妈身体恢复情况" name="tweenty_fourth_mom_recovery">
                        <Input />
                    </Form.Item>
                    <Form.Item label="宝宝睡眠、生长情况" name="tweenty_fourth_baby_sleep_grow">
                        <Input />
                    </Form.Item>
                    <Form.Item label="其他异常" name="other_exception">
                        <Input placeholder="" />
                    </Form.Item>
                </Form>
            </div>}

            {currentDay === 'R7' && <div>
                <Form form={form7} {...formItemLayout} style={{ marginTop: 10 }}>
                    <Form.Item label="回访时间" name="interview_date">
                        <DatePicker />
                    </Form.Item>
                    <Form.Item label="妈妈身体恢复情况" name="thirty_second_mom_recovery">
                        <Input />
                    </Form.Item>
                    <Form.Item label="宝宝睡眠、生长情况" name="thirty_second_baby_sleep_grow">
                        <Input />
                    </Form.Item>
                    <Form.Item label="恶露情况" name="lochia">
                        <Input />
                    </Form.Item>
                    <Form.Item label="宝宝疫苗情况" name="baby_vaccine">
                        <Input />
                    </Form.Item>
                    <Form.Item label="各部门服务情况" name="all_dep_service_level">
                        <Radio.Group >
                            <Radio value={0}>未知（默认）</Radio>
                            <Radio value={1}>很满意</Radio>
                            <Radio value={2}>满意</Radio>
                            <Radio value={3}>一般</Radio>
                            <Radio value={4}>不满意</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item label="其他异常" name="other_exception">
                        <Input placeholder="" />
                    </Form.Item>
                </Form>
            </div>}

            {currentDay === 'L1' && <div>
                <Form form={form8} {...formItemLayout} style={{ marginTop: 10 }} >
                    <Form.Item label="回访时间" name="interview_date">
                        <DatePicker />
                    </Form.Item>
                    <Form.Item label="预计离所时间" name="expect_leave_date">
                        <DatePicker />
                    </Form.Item>
                    <Form.Item label="宣导" name="leave_before_three_prop_edu">
                        <Checkbox.Group options={options4} />
                    </Form.Item>
                    <Form.Item label="备餐" name="leave_before_three_food">
                        <Checkbox.Group options={options5} />
                    </Form.Item>

                    <Form.Item label="其他异常" name="other_exception">
                        <Input placeholder="" />
                    </Form.Item>
                </Form>
            </div>}

            {currentDay === 'L2' && <div>
                <Form form={form9} {...formItemLayout} style={{ marginTop: 10 }}>
                    <Form.Item label="回访时间" name="interview_date">
                        <DatePicker />
                    </Form.Item>
                    <Form.Item label="离所流程宣导" name="leave_before_one_prop_edu">
                        <Checkbox.Group options={options6} />
                    </Form.Item>
                    <Form.Item label="车送目的地址" name="destination">
                        <Input />
                    </Form.Item>
                    <Form.Item label="其他异常" name="other_exception">
                        <Input placeholder="" />
                    </Form.Item>
                </Form>
            </div>}
        </Modal>
    </Fragment>
}